import { render } from "./PhoneAuth.vue?vue&type=template&id=13fbd059"
import script from "./PhoneAuth.vue?vue&type=script&lang=js"
export * from "./PhoneAuth.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__